export enum DeliveryMethodEnum {

    RO4ROAD = 'RO4-ROAD',
    ROSROADBUS = 'RO5-ROAD (BUS)',
    RO2ROADEXPRESS = 'RO2-ROAD-EXPRESS',
    RO3ROADQUICKER = 'RO3-ROAD-QUICKER',
    RODROADREGULAR = 'ROD-ROAD-REGULAR',
    SASEAANDAIR = 'S&A-SEA AND AIR',
    NANA = 'NA-NA',
    ARAIRROAD = 'A&R-AIR/ROAD',
    ASAIRSEA = 'A&S-AIR/SEA',
    ATAIRTRAIN = 'A&T-AIR/TRAIN',
    AIRAIR= 'AIR-AIR',
    COUCOURIER = 'COU-COURIER',
    HNDBYHAND = 'HND-BY HAND',
    RTROADTRAIN = 'R&T-ROAD/TRAIN',
    SEASEA = 'SEA-SEA',
    TRNTRAIN = 'TRN-TRAIN',
    EXCEXPRESSCARGO = 'EXC-EXPRESS CARGO'

}
